export const localData = 
    [
        "贷款用途",
        "资金需求",
        "还款能力",
        "信用记录",
        "收入来源",
        "工作稳定性",
        "资产情况",
        "负债情况",
        "贷款期限",
        "利率期望",
        "产品介绍",
        "利率优惠",
        "贷款额度",
        "还款方式",
        "灵活期限",
        "快速审批",
        "无抵押贷款",
        "低息贷款",
        "信用贷款",
        "房屋抵押贷款",
        "车辆抵押贷款",
        "客户沟通技巧",
        "倾听需求",
        "建立信任",
        "提供解决方案",
        "消除疑虑",
        "强调优势",
        "引导决策",
        "保持耐心",
        "积极回应",
        "清晰表达",
        "适时跟进",
        "销售话术",
        "我们可以为您量身定制方案",
        "这款产品非常适合您的需求",
        "审批快，放款更快",
        "利率低至X%，节省成本",
        "无需抵押，手续简单",
        "您的信用记录非常好，可以享受优惠",
        "我们可以帮您解决资金周转问题",
        "这是目前市场上最受欢迎的产品",
        "您只需要提供基本资料，剩下的交给我们",
        "现在申请，还能享受限时优惠",
        "客户异议处理",
        "利率太高",
        "手续太麻烦",
        "担心还款压力",
        "信用记录不好",
        "贷款额度不够",
        "审批时间太长",
        "需要抵押物",
        "对产品不了解",
        "已有其他贷款",
        "暂时不需要",
        "促成成交",
        "限时优惠",
        "名额有限",
        "提前放款",
        "降低利率",
        "增加额度",
        "简化手续",
        "提供增值服务",
        "强调紧迫性",
        "提供成功案例",
        "强调安全性",
        "客户维护",
        "定期回访",
        "节日问候",
        "提供最新产品信息",
        "解答疑问",
        "收集反馈",
        "推荐附加服务",
        "建立长期关系",
        "关注客户动态",
        "提供理财建议",
        "感谢客户信任",
        "市场推广",
        "线上广告",
        "线下活动",
        "社交媒体推广",
        "合作渠道",
        "口碑营销",
        "客户推荐奖励",
        "精准投放",
        "数据分析",
        "品牌宣传",
        "优惠活动",
        "团队管理",
        "目标设定",
        "业绩考核",
        "培训提升",
        "激励机制",
        "团队协作",
        "数据分析",
        "客户分配",
        "资源整合",
        "问题解决",
        "经验分享",
        "风险控制",
        "信用评估",
        "还款能力分析",
        "资产核实",
        "风险预警",
        "合规操作",
        "客户背景调查",
        "合同审核",
        "贷后管理",
        "逾期处理",
        "法律支持"
      ]